import {AxiosError} from 'axios';
import {POST_CREATE_CANDIDATE_PROFILE_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateCandidateProfile = ({onError, onSuccess}: Input = {}) => {
  const postCreateCandidateProfile = async (reqBody: any) => {
    const res = await axiosClient.post<void>(POST_CREATE_CANDIDATE_PROFILE_URL, reqBody);

    return res.data;
  };

  return useCustomMutation(postCreateCandidateProfile, {
    onSuccess,
    onError,
  });
};
